module.exports = __webpack_public_path__ + "img/ic_done_sel.fda97e70.svg";